import ActionButton from "./ActionButton";

const DeleteButton = ({ onClick, classes }) => (
    <ActionButton onClick={onClick} classes={`${classes} danger-but`}>
        <i className="fas fa-trash"></i>
    </ActionButton>
);

export default DeleteButton;